import React, { useState } from "react";
import { Button, Popover, Checkbox } from "antd";
import { FilterOutlined } from "@ant-design/icons";

const DashboardFilter = ({ filterData, onApplyFilters }) => {
    const [filters, setFilters] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [popoverVisible, setPopoverVisible] = useState(false);

    const locationLabels = {
        "garment_super_market": "Received",
        "In Transit": "Transit to GSM"
    };

    const handleAddFilter = () => {
        onApplyFilters(selectedFilters); // Apply the filters to parent component
        setPopoverVisible(false);
    };

    const handleRemoveFilters = () => {
        setSelectedFilters([]);
        onApplyFilters([]); // Reset the filters in parent
    };

    const handleCheckboxChange = (checkedValues) => {
        setSelectedFilters(checkedValues);
    };

    const popoverContent = (
        <div style={{ width: 200 }}>
            <Checkbox.Group 
                style={{ display: "flex", flexDirection: "column" }} 
                value={selectedFilters} 
                onChange={handleCheckboxChange}
            >
                {Object.entries(locationLabels).map(([location, label]) => (
                    <Checkbox key={location} value={location} style={{ fontSize: "16px", padding: "5px" }}>
                        {label}
                    </Checkbox>
                ))}
            </Checkbox.Group>
            <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between" }}>
                <Button type="default" onClick={handleRemoveFilters}>Reset</Button>
                <Button type="primary" onClick={handleAddFilter}>Apply Filters</Button>
            </div>
        </div>
    );

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "flex-end", paddingTop:'5px' }}>
                <Popover
                    content={popoverContent}
                    title="Add Filter"
                    trigger="click"
                    open={popoverVisible}
                    onOpenChange={setPopoverVisible}
                >
                    <Button icon={<FilterOutlined />}>Add Filter</Button>
                </Popover>
            </div>
        </div>
    );
};

export default DashboardFilter;
